import React from 'react';

export default function EncodedDataImage({ coinInfo }) {
  return (
    coinInfo.coin === 'ETH'
      ? <img alt={coinInfo.coin || ''} src={`${coinInfo.icon_image}`} width="20px" style={{ margin: '0px 4px 0px 7px' }} />
      : <img alt={coinInfo.coin || ''} src={`${coinInfo.icon_image}`} width="30px" style={{ borderRadius: 100 }} />
  );
}
